<div class="row row-mobile g-2 gx-md-5 footer-border px-4  pt-lg-4">
    <div class="col-12 col-md-4 col-lg-3   footer-chip-shop-by footer-data">
        <h6 class="footer-heading">{{footerdata?.links?.columns_1?.[0]?.menu_name}}</h6>
        <ul class="list-unstyled">
            <li *ngFor="let footer of footerdata?.links?.columns_1.slice(1)">
                <a (click)="onClick($event, footer?.menu_link,footer?.menu_name)" class="cursor-pointer">{{footer?.menu_name}}</a>
            </li>
        </ul>
         <h6 class="footer-heading">{{footerdata?.links?.columns_2?.[0]?.menu_name}}</h6>
        <ul class="list-unstyled">
            <li *ngFor="let footer of footerdata?.links?.columns_2.slice(1)">
                <a (click)="onClick($event, footer?.menu_link,footer?.menu_name)" class="cursor-pointer">{{footer?.menu_name}}</a>
            </li>
        </ul>
    </div>
    <ng-container>
        <div class="col-12 col-md-4 col-lg-3  my-account-garage footer-data">
            <h6 class="footer-heading">{{footerdata?.links?.columns_3?.[0]?.menu_name}}</h6>
            <ul class="list-unstyled">
                <li><a class="mb-0 cursor-pointer"
                        (click)="onClick($event, footerdata?.links?.columns_3?.[1]?.menu_link,footerdata?.links?.columns_3?.[1]?.menu_name)">{{footerdata?.links?.columns_3?.[1]?.menu_name}}</a>
                </li>
                <ng-container>
                <li *ngFor="let footer of footerdata?.links?.columns_3.slice(2); let i = index">
                    <a (click)="onClick($event, footer?.menu_link ,footer?.menu_name)" class="cursor-pointer">
                         {{ footer?.menu_name }}
                    </a>
                </li>
                </ng-container>
            </ul>
        </div>
    </ng-container>
    <ng-container>
         <div class="col-12 col-md-4 col-lg-3   footer-data  pe-0 d-md-block"> 
            <h6 class="footer-heading cursor-pointer"
                (click)="onClick($event, footerdata?.links?.columns_4?.[0]?.menu_link,footerdata?.links?.columns_4?.[0]?.menu_name)">
                {{footerdata?.links?.columns_4?.[0]?.menu_name}}</h6>
            <ul class="list-unstyled" >
                <li *ngFor="let footer of footerdata?.links?.columns_4.slice(1) "><a class="cursor-pointer" [ngClass]="{'top-cus': footer.menu_name === 'Become an Installer'}"
                        (click)="onClick($event, footer.menu_link,footer?.menu_name)">{{ footer.menu_name }} </a>
                </li>
            </ul>
        </div> 
    </ng-container>
    <ng-container *ngIf="showContactDetails">
        <div class="col-12 col-md-4 col-lg-3  social-info footer-data">
            <img [src]="cdnImagePath + footerdata?.footerLogo?.[0]?.footer_logo" width="180" height="70" class="pb-4 footer-custum-logo img-fluid cursor-pointer"
                alt="footer-logo" [routerLink]="['/']" (click)="scrollTop()">
            <div [innerHTML]="footerdata?.contactDetails?.[0]?.company_info"></div>
            <ul class="list-unstyled">
                <li class="mt-4 d-flex gap-2">
                    <ng-container *ngIf="!chTheme6">
                          <span *ngFor="let icon of footerdata?.socialIconsCopyright.slice(0,4)">
                        <a *ngIf="isExternal(icon?.menu_link)" class="social-icon" [href]="icon?.menu_link"
                            target="_blank" rel="noopener noreferrer">
                            <img *ngIf="icon?.link_style == 'Circle'"  [src]="cdnImagePath + icon?.icon_image"
                                [alt]="icon?.menu_name">
                        </a>
                    </span>
                    </ng-container>
                    <ng-container *ngIf="chTheme6">
                    <span *ngFor="let icon of footerdata?.socialIconsCopyright.slice(0,5)">
                        <a *ngIf="isExternal(icon?.menu_link)" class="social-icon" [href]="icon?.menu_link"
                            target="_blank" rel="noopener noreferrer">
                            <img *ngIf="icon?.link_style == 'Circle'"  [src]="cdnImagePath + icon?.icon_image"
                                [alt]="icon?.menu_name">
                        </a>
                    </span>
                    </ng-container>
                </li>
            </ul>
        </div>
    </ng-container>
</div>



